import { UtmParameters } from '@griply/types';
import { Paths } from 'shared/routes/paths';

import {
  globalQueryParamOptions,
  pathAllowedQueryParamOptions,
  QueryParamOptions,
} from './globally-allowed-query-parameters';

export const getGlobalAllowedSearchParameters = (search?: URLSearchParams) => {
  const params = search ?? new URLSearchParams(window.location.search);

  return globalQueryParamOptions.reduce((acc, globalQueryParamOption) => {
    const values = params.getAll(globalQueryParamOption);
    if (values) {
      values.forEach((value) => acc.append(globalQueryParamOption, value));
    }

    return acc;
  }, new URLSearchParams());
};

export const getPathAllowedSearchParams = (
  path: Paths,
  search?: URLSearchParams,
  paramsToIgnore: (QueryParamOptions | UtmParameters)[] = [],
) => {
  const params = search ?? new URLSearchParams(window.location.search);
  const pathAllowedParams = pathAllowedQueryParamOptions[path] ?? [];
  const filteredAllowedParams = paramsToIgnore.length
    ? pathAllowedParams.filter((param) => !paramsToIgnore.includes(param))
    : pathAllowedParams;

  return filteredAllowedParams.reduce((acc, queryParamOption) => {
    const values = params.getAll(queryParamOption);
    if (values) {
      values.forEach((value) => acc.append(queryParamOption, value));
    }

    return acc;
  }, new URLSearchParams());
};
